export const SupportedChainId = {
    MAINNET: 1,
    GOERLI: 5,
    POLYGON: 137,
    MUMBAI: 80001
}